import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import brand from "../../data/brand";

const LogoHero = () => {
  return (
    <section className="bg-cream pb-12">
      <div className="flex overflow-hidden pointer-events-none">
        <TranslateWrapper>
          <LogoItems brands={brand.slice(0, brand.length / 2)} />
        </TranslateWrapper>
        <TranslateWrapper>
          <LogoItems brands={brand.slice(0, brand.length / 2)} />
        </TranslateWrapper>
      </div>
      <div className="flex overflow-hidden mt-4 pointer-events-none">
        <TranslateWrapper reverse>
          <LogoItems brands={brand.slice(brand.length / 2)} />
        </TranslateWrapper>
        <TranslateWrapper reverse>
          <LogoItems brands={brand.slice(brand.length / 2)} />
        </TranslateWrapper>
      </div>
      <div className="w-full px-8 py-8 md:py-12 flex flex-col items-center">
        {/* <h1 className="text-center text-4xl md:text-6xl max-w-xl font-light font-cormorant">
          Nos Marques
        </h1> */}
        <Link to="/our-brands">
          <button className="bg-cocoa text-cream text-base md:text-lg font-medium px-8 py-2 mt-6 shadow-[3px_3px_0_black] hover:shadow-[1px_1px_0_black] hover:translate-x-[3px] hover:translate-y-[3px] transition-all">
            Découvrir
          </button>
        </Link>
      </div>
    </section>
  );
};

const TranslateWrapper = ({ children, reverse }) => {
  return (
    <motion.div
      initial={{ translateX: reverse ? "-100%" : "0%" }}
      animate={{ translateX: reverse ? "0%" : "-100%" }}
      transition={{ duration: 50, repeat: Infinity, ease: "linear" }}
      className="flex gap-4 px-2"
    >
      {children}
    </motion.div>
  );
};

const LogoItem = ({ brand }) => {
  return (
    <a
      href={brand.link}
      rel="nofollow"
      target="_blank"
      className="w-24 md:w-36 lg:w-48 h-24 md:h-36 lg:h-48 flex justify-center items-center hover:bg-biscotti transition-colors overflow-hidden"
    >
      <img
        src={brand.imageUrl}
        alt={brand.name}
        className="w-4/5 h-4/5 object-contain"
        style={{
          maxWidth: "100%",
          maxHeight: "100%"
        }}
      />
    </a>
  );
};

const LogoItems = ({ brands }) => (
  <>
    {brands.map((brand, index) => (
      <LogoItem key={index} brand={brand} />
    ))}
  </>
);

export default LogoHero;